// PIN lock simple guardado en localStorage (hash SHA-256, no plaintext).
// El PIN protege el ACCESO LOCAL a la app, no la sesión backend.
// Cuando el usuario ya tiene cookie httpOnly válida y PIN configurado,
// la app le pide solo el PIN (no Google de nuevo).

const PIN_HASH_KEY = "pin-hash-v1";
const PIN_BYPASS_KEY = "pin-bypass-until";
const DEVICE_KEY = "pin-device-key-v1";

async function sha256(text) {
  const enc = new TextEncoder().encode(text);
  const hash = await crypto.subtle.digest("SHA-256", enc);
  return Array.from(new Uint8Array(hash)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

export async function setPin(pin) {
  const hash = await sha256(String(pin));
  localStorage.setItem(PIN_HASH_KEY, hash);
}

export function hasPin() {
  return !!localStorage.getItem(PIN_HASH_KEY);
}

export async function verifyPin(pin) {
  const stored = localStorage.getItem(PIN_HASH_KEY);
  if (!stored) return false;
  const hash = await sha256(String(pin));
  return stored === hash;
}

export function removePin() {
  localStorage.removeItem(PIN_HASH_KEY);
  localStorage.removeItem(PIN_BYPASS_KEY);
  localStorage.removeItem(DEVICE_KEY);
}

// Mark PIN as "unlocked" for a session — avoids re-asking within the same tab.
export function unlockPin(minutes = 60 * 24) {
  const until = Date.now() + minutes * 60 * 1000;
  sessionStorage.setItem(PIN_BYPASS_KEY, String(until));
}

export function isPinUnlocked() {
  const until = parseInt(sessionStorage.getItem(PIN_BYPASS_KEY) || "0", 10);
  return until > Date.now();
}

export function lockPin() {
  sessionStorage.removeItem(PIN_BYPASS_KEY);
}

// Device key — links this local PIN to the server-side enrollment.
// Once set, PIN entry can call /api/auth/pin/login directly without Google.
export function getDeviceKey() {
  try { return localStorage.getItem(DEVICE_KEY); } catch { return null; }
}
export function setDeviceKey(key) {
  try { localStorage.setItem(DEVICE_KEY, key); } catch {}
}
export function clearDeviceKey() {
  try { localStorage.removeItem(DEVICE_KEY); } catch {}
}
export function hasDeviceKey() {
  return !!getDeviceKey();
}
